// frontend/src/pages/teacher/TeacherLessonListPage.js (فایل جدید)

import React, { useState, useEffect, useCallback } from 'react';
import { useParams, Link, useNavigate } from 'react-router-dom';
import axiosInstance from '../../modules/api';
import { FaBook, FaSpinner, FaArrowLeft, FaComments } from 'react-icons/fa';

const TeacherLessonListPage = () => {
    const { courseId } = useParams();
    const navigate = useNavigate();
    const [lessons, setLessons] = useState([]);
    const [courseTitle, setCourseTitle] = useState('...');
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const fetchLessons = useCallback(async () => {
        setLoading(true);
        try {
            // API که لیست دروس یک دوره را برای معلم برمی‌گرداند
            const response = await axiosInstance.get(`/core/teacher/courses/${courseId}/lessons/`);
            setLessons(response.data);
            
            // (دریافت نام دوره - موقتی از اولین درس)
            if (response.data.length > 0) {
                // TODO: نام دوره باید از API جداگانه گرفته شود
                // setCourseTitle(response.data[0].unit_info.course_title); 
            }
        } catch (err) {
            console.error("Error fetching lessons:", err);
            setError(err.response?.data?.detail || "خطا در بارگذاری دروس.");
        } finally {
            setLoading(false);
        }
    }, [courseId]);

    useEffect(() => {
        fetchLessons();
    }, [fetchLessons]);

    const renderLessonList = () => {
        if (loading) return <div className="text-center p-5"><FaSpinner className="spinner" /></div>;
        if (error) return <div className="alert alert-danger">{error}</div>;
        if (lessons.length === 0) return <p className="text-center text-gray-400 p-4">هنوز درسی برای این دوره ایجاد نشده است.</p>;

        return (
            <div className="lessons-grid">
                {lessons.map(lesson => (
                    <div key={lesson.id} className="lesson-card-link" style={{justifyContent: 'space-between'}}>
                        <div className="lesson-card-info">
                            <FaBook />
                            <span className="font-medium">درس {lesson.order}: {lesson.title}</span>
                        </div>
                        {/* دکمه ورود به تالار گفتگو */}
                        <button 
                            className="button button-primary" 
                            style={{fontSize: '0.8rem', padding: '5px 10px'}}
                            onClick={() => navigate(`/teacher/lesson/${lesson.id}/discussion`)}
                        >
                            <FaComments /> مشاهده گفتگو
                        </button>
                    </div>
                ))}
            </div>
        );
    };

    return (
        <div className="page-container">
            <Link to="/teacher/courses" className="button button-secondary mb-6 inline-flex items-center">
                <FaArrowLeft className="ml-2" /> بازگشت به لیست دوره‌ها
            </Link>

            <div className="page-header" style={{paddingBottom: '10px', marginBottom: '20px'}}>
                <div>
                    <h1>مدیریت دروس و گفتگوها</h1>
                    <p>دوره: {courseTitle}</p>
                </div>
            </div>

            <div className="data-table-container">
                {renderLessonList()}
            </div>
        </div>
    );
};

export default TeacherLessonListPage;